import {SelectionGeneratorOption} from "./selection-generator.component";

export class SelectionGeneratedField {
  text? = "";

  constructor(readonly options: SelectionGeneratorOption[]) {
  }
}
